import { AnchorHTMLAttributes } from 'react';
import { LinkTarget } from 'types/navigation.js';
import { PW_LINK_SELECTOR } from 'utilities/consts/variable-types.js';

/**
 * We need to directly manage if we want to prevent default or not here and on the map click event directly
 * Managing this as a global handler does not work and caused bugs
 * See setPreventDefault fn for the events where this is called
 *
 * Be vigilant when adding new functionality,
 * other click event listeners may have already propagated by the time your listener is called.
 */
export const LinkFactoryOnClick = ({
  className,
  style,
  children,
  onClick,
  target,
  ...rest
}: Omit<Partial<AnchorHTMLAttributes<HTMLAnchorElement>>, 'href'> & {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  target?: `${LinkTarget}`;
}) => {
  return (
    <a {...rest} className={className} style={style} onClick={onClick} data-testid={PW_LINK_SELECTOR}>
      {children}
    </a>
  );
};
